import * as $ from "jquery";
import * as ko from "knockout";
import Bao from "../../services/bao-service";
import BaoDialogViewModel from "../bao-dialog";
import template from "./password-changer.html";

export class PasswordChanger {
	public LanguageSymbol = ko.observable();
	public Username = ko.observable();
	public OldPassword = ko.observable();

	public Result = false;

	private CaptionUsername = ko.observable();
	private CaptionOldPassword = ko.observable();
	private CaptionNewPassword = ko.observable();
	private CaptionNewPassword2 = ko.observable();
	private MessageMandatoryFields = ko.observable();
	private MessagePasswordNotMatching = ko.observable();
	private SecurityPolicyDescription = ko.observable();
	private NewPassword = ko.observable();
	private NewPassword2 = ko.observable();

	private Dialog: BaoDialogViewModel;
	private _subs: KnockoutSubscription[] = [];

	constructor() {
		this._subs.push(this.LanguageSymbol.subscribe(() => {
			this.translateForm();
		}));
		if (Bao.Session.Language != null && Bao.Session.Language.Symbol != null && Bao.Session.Language.Symbol() != null) {
			this.LanguageSymbol(Bao.Session.Language.Symbol());
		}
		if (Bao.Session.User != null) {
			this.Username(Bao.Session.User.Username());
		}
		this.getSecPolicy();
		this.initDialog();
	}

	public dispose() {
		this._subs.forEach((d) => {
			d.dispose();
		});
		this.Dialog.dispose();
	}
	public Open(): JQueryPromise<boolean> {
		const def = $.Deferred<boolean>();
		this.Dialog.Open().then(() => {
			def.resolve(this.Result);
		});
		this.Dialog.IsLoading(true);
		Bao.post("Login/ChangePasswordDialog", (value) => {
			ko.map.fromJS(this, value.Model);
			this.Dialog.IsLoading(false);
		});

		return def.promise();
	}

	private translateForm() {
		return Bao.Session.GetCaptions("ChangePasswordDialog", this.LanguageSymbol()).then((captions) => {
			this.CaptionUsername(captions.lblUsername);
			this.CaptionOldPassword(captions.lblOldPassword);
			this.CaptionNewPassword(captions.lblNewPassword);
			this.CaptionNewPassword2(captions.lblNewPassword2);
			this.MessageMandatoryFields(captions.msgFillMandatoryFields);
			this.MessagePasswordNotMatching(captions.msgPasswordNotMatching);
		});
	}

	private getSecPolicy() {
		return Bao.post("Login/GetSecurityPolicy", (securityPolicyDescription) => {
			this.SecurityPolicyDescription(securityPolicyDescription);
		});
	}
	private changePassword() {
		if (this.CompleteCheck()) {
			Bao.post("Login/ChangePassword", JSON.stringify({
				changePasswordModel: ko.map.toJS(this)
			}), (value) => {
				this.Dialog.IsLoading(false);
				if (value.Result == true) {
					this.Result = true;
					this.Dialog.Close();
					this.dispose();
				} else {
					new BaoDialogViewModel(Bao.Session.ApplicationName, value.Message, "info");
				}
			});
		}

	}

	private CompleteCheck() {
		let isComplete = true;
		let _message = this.MessageMandatoryFields();
		if (Bao.Utils.String.IsNullOrEmpty(this.OldPassword())) {
			isComplete = false;
		}
		if (Bao.Utils.String.IsNullOrEmpty(this.NewPassword())) {
			isComplete = false;
		}
		if (Bao.Utils.String.IsNullOrEmpty(this.NewPassword2())) {
			isComplete = false;
		}
		if (this.NewPassword2() != this.NewPassword()) {
			isComplete = false;
			_message = this.MessagePasswordNotMatching();
		}
		if (!isComplete) {
			new BaoDialogViewModel(Bao.Session.ApplicationName, _message, "info");
		}
		return isComplete;
	}

	private initDialog() {
		const captionOK = Bao.Session.GetMessage("msgOk");
		const captionCancel = Bao.Session.GetMessage("msgCancel");
		this.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
		this.Dialog.Buttons([
			{
				Title: captionOK,
				Click: () => {
					this.changePassword();
				},
				Enabled: ko.observable(true)
			},
			{
				Title: captionCancel,
				Click: () => {
					this.Dialog.Close();
				},
				Enabled: ko.observable(true)
			}]);
		this.Dialog.Template(template);
		this.Dialog.ViewModel(this);
		this.Dialog.Width(700);
	}
}
